import { Clinic, Facility } from '../model'

export const DEFAULT_TIMEZONE = 'America/New_York'

export function getTimeZone(clinic?: Clinic, facility?: Facility): string {
  return facility?.timezone ?? clinic?.settings.defaultTimezone ?? DEFAULT_TIMEZONE
}
